export default "__VITE_ASSET__HzkVsZXx__"